import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import getClassName from 'src/common/utils/getClassName';
import UniversalLink from 'src/common/components/UniversalLink';
import Icon from 'src/common/components/IconDS22';
import { PATHS } from 'src/common/constants';
import useBoats from 'src/common/hooks/useBoats';
import StatusFilter from 'src/calendar/components/StatusFilter';
import ListingsFilter from 'src/calendar/components/ListingsFilter';
import Button from 'src/common/components/Button';
import s from './Filters.module.scss';

type FiltersProps = {
  classNameModifier?: string;
  hasCalendarSyncAccess?: boolean;
  syncAllListings?: () => Promise<void>;
  syncing?: boolean;
};

const Filters: FC<FiltersProps> = ({
  classNameModifier = '',
  syncAllListings,
  hasCalendarSyncAccess,
  syncing,
}) => {
  const { allBoats } = useBoats();
  return (
    <div className={getClassName(s, 'root', `${classNameModifier}`)}>
      {syncAllListings && (
        <div className={s.syncButton}>
          <Button
            onClick={syncAllListings}
            type="button"
            className={s.connectCalendar}
            classNameModifier="tertiary noMargin small whiteBackground rounded"
            submitting={syncing}
            fullWidth
          >
            <Icon id="reload" size="m" />
            Sync
          </Button>
        </div>
      )}
      <div className={s.filterCopy}>
        Filter by
      </div>
      {allBoats.length > 1 && (
        <ListingsFilter
          classNameModifier={classNameModifier}
        />
      )}
      <Route exact path={PATHS.CALENDAR}>
        <StatusFilter
          classNameModifier={classNameModifier}
        />
        {hasCalendarSyncAccess && (
          <div className={s.connectCalendarContainer}>
            <UniversalLink
              className={s.connectCalendarButton}
              to={PATHS.SYNC_CALENDAR}
            >
              <Icon id="gear" />
            </UniversalLink>
          </div>
        )}
      </Route>
    </div>
  );
};

export default Filters;
